<template>
  <Transition name="slide-down">
    <div
      v-if="showBanner && userStore.isInGuestMode()"
      class="fixed top-0 left-0 right-0 z-40 bg-blue-600 text-white py-2 px-4"
    >
      <div class="flex items-center justify-between max-w-7xl mx-auto">
        <div class="flex items-center space-x-3">
          <NIcon size="18"><InfoIcon /></NIcon>
          <span class="text-sm">
            {{ $t("page.login.guestMode.message") }}
          </span>
        </div>

        <div class="flex items-center space-x-2">
          <NButton size="small" type="primary" ghost @click="handleLogin">
            {{ $t("page.login.common.login") }}
          </NButton>

          <NButton size="small" quaternary @click="dismissBanner">
            <template #icon>
              <NIcon><CloseIcon /></NIcon>
            </template>
          </NButton>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
  import { computed, h, onMounted } from "vue";
  import { NButton, NIcon } from "naive-ui";
  import { useAuthStore } from "@/store/modules/auth";
  import { useUserStore } from "@/store/modules/user";
  import { $t } from "@/locales";

  // Simple info icon component
  const InfoIcon = () =>
    h(
      "svg",
      {
        viewBox: "0 0 24 24",
        fill: "currentColor",
      },
      [
        h("path", {
          d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,7H13V9H11V7M11,11H13V17H11V11Z",
        }),
      ]
    );

  // Simple close icon component
  const CloseIcon = () =>
    h(
      "svg",
      {
        viewBox: "0 0 24 24",
        fill: "currentColor",
      },
      [
        h("path", {
          d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
        }),
      ]
    );

  const authStore = useAuthStore();
  const userStore = useUserStore();

  const showBanner = computed(() => {
    // Don't show if user previously dismissed it
    if (localStorage.getItem("guestBannerDismissed") === "true") {
      return false;
    }
    return authStore.showGuestBanner;
  });

  const handleLogin = () => {
    authStore.setOverlayVisibility(true);
  };

  const dismissBanner = () => {
    authStore.setGuestBannerVisibility(false);
    // Remember user preference
    localStorage.setItem("guestBannerDismissed", "true");
  };

  // Clear the dismissed state when component mounts if user is not in guest mode
  onMounted(() => {
    if (!userStore.isInGuestMode()) {
      localStorage.removeItem("guestBannerDismissed");
    }
  });
</script>

<style scoped>
  .slide-down-enter-active,
  .slide-down-leave-active {
    transition: transform 0.3s ease;
  }

  .slide-down-enter-from,
  .slide-down-leave-to {
    transform: translateY(-100%);
  }
</style>
